module.exports = __webpack_public_path__ + "static/media/cleric.32a2d687.png";